import React from 'react';
import LandingPage from 'containers/LandingPage';
import SignUpContainer from 'containers/SignUpContainer';
import withIpGeoLocationData from 'containers/withIpGeoLocationData';
import { parseQuery } from 'utils/web';
import SignUpPage from './SignUpPage';

const ZONE_BLACKLIST = [
  //'bethlehem'
];

const DISABLE_IP_GEOLOCATION = !ZONE_BLACKLIST.length;

function SignUpContainerPage({ location, ipGeoLocationData }) {
  if (!DISABLE_IP_GEOLOCATION) {
    if (!ipGeoLocationData.ipGeoLocationData && ipGeoLocationData.loading) {
      return null;
    }

    const overrideZone = parseQuery(location.search).promotion;
    const data = ipGeoLocationData.ipGeoLocationData;
    const zone = overrideZone || (data && data.promotionZone);

    if (zone && ZONE_BLACKLIST.includes(zone)) {
      return <LandingPage location={location} />;
    }
  }

  return (
    <SignUpContainer signUpViewComponent={SignUpPage} location={location} />
  );
}

const withGeoData = withIpGeoLocationData({
  skip: DISABLE_IP_GEOLOCATION
});

export default withGeoData(SignUpContainerPage);
